<template>
  <section>
    <!-- 统计文字 -->
    <el-row class="statusRowWhite">
			<div class="RowChild">
        	<el-date-picker
          	class="xs24"
            v-model="dateVal"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="今天"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
      </div>
				<div class="RowChild">
          <el-button class="xs24" type="primary" plain @click="changeDate(1)" id="today">昨天</el-button>
          <el-button class="xs24" type="primary" plain @click="changeDate(7)" id="seven">最近7天</el-button>
  		</div>
  		<div class="RowChild">
				&nbsp;平台来源： &nbsp;
				<el-select class="xs24" v-model="pdata.platform_id" placeholder="请选择小游戏来源" @change="getField()" clearable>
					<el-option :label="v.platform_name" :value="v.platform_id" v-for="(v,i) in get_issued_app_platform" :key="v.platform_id"></el-option>
				</el-select>
			</div>
				<div class="RowChild">
					&nbsp;小游戏名称： &nbsp;
					<searchApp class="xs24" @getid="changeId" compare="issued" :pholder="pholder"></searchApp>
				</div>
    </el-row>
    <!-- 按钮及日期行 -->
    <el-row class="" :gutter="10" style="padding:15px;">
	  	<el-col :xs="24" :sm="8" :md="6" :lg="6" :xl="3" v-for="(item,index) in cardParams" >
	  			<div class="card"  v-loading="cardParams[index].isLoading">
	  				<div v-if="cardIndex>index">
	  					<div class="cdName"><b>{{card[cardParams[index].name].title}}</b><span>最近7天   合计：{{card[cardParams[index].name].total}}</span></div>
		  				<div class="today">昨天：<span>{{card[cardParams[index].name].yesterday}}</span> <b v-if="index==0||index==1">人</b> <b v-else-if="index==7">%</b><b v-else>元</b></div>
		  				<div class="yestoday">
		  					对比前天：
		  					<span :class="card[cardParams[index].name].compare_day>0?'up':'down'">
		  						<i class="el-icon-top" v-if="card[cardParams[index].name].compare_day>0"></i>
		  						<i class="el-icon-bottom" v-if="card[cardParams[index].name].compare_day<0"></i>
		  						<b :class="card[cardParams[index].name].compare_day==0?'none':''"><i class="el-icon-minus" v-if="card[cardParams[index].name].compare_day==0"></i> {{card[cardParams[index].name].compare_day}}%</b>
		  					</span>
		  				</div>
		  				<div class="yestoday">
		  					对比上周：
		  					<span :class="card[cardParams[index].name].compare_week>0?'up':'down'">
		  						<i class="el-icon-top" v-if="card[cardParams[index].name].compare_week>0"></i>
		  						<i class="el-icon-bottom" v-if="card[cardParams[index].name].compare_week<0"></i>
		  						<b :class="card[cardParams[index].name].compare_week==0?'none':''"><i class="el-icon-minus" v-if="card[cardParams[index].name].compare_week==0"></i> {{card[cardParams[index].name].compare_week}}%</b>
		  					</span>
		  				</div>
	  				</div>
	  				
	  			</div>
	  	</el-col>
	  	
    </el-row>

    <!-- 图表 --> 
    <el-row   :gutter="10" style="padding:15px;" >
   <!-- 	 <div v-for="(item,index) in chartParams"></div>-->
    	 <el-col :xs="24" :sm="24" :md="24" :lg="index==0?24:12" :xl="index==0?24:12" v-for="(item,index) in chartParams" >
    	 		<div class="card"  v-loading="chartParams[index].isLoading">
    	 			<div :id="'option_'+item.name" style="width:100%; height:500px;"></div>
    	 		</div>
    	 </el-col>
      
    </el-row>
    
    
  </section>
</template>

<script>
import $ from "jquery";	
import { getSummaryIndex, getValidProductPlatform} from "../../api/api";
import echarts from "echarts";


export default {
  data() {
    return {
    	isChartShow: true,
      chartColumn: null,
      timer:null,
      pdata: {
        issued_app_id: "",
        platform_id: "",
        sdate: new Date(new Date().getTime() - 3600 * 1000  * 24)
          .toISOString()
          .slice(0, 10),
        edate: new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      },
      
      
      card:{},
      cardParams:[ {"name":"visit_uv_new","isLoading":true}, {"name":"visit_uv","isLoading":true}, {"name":"sell_data","isLoading":true}, {"name":"origin_income","isLoading":true}, {"name":"buy_data","isLoading":true}, {"name":"cp_data","isLoading":true}, {"name":"profit_data","isLoading":true}, {"name":"profit_rate","isLoading":true} ],
      cardIndex:0,
      chart:{},
      chartParams:[ {"name":"visit_uv_new","isLoading":true}, {"name":"visit_uv","isLoading":true}, {"name":"sell_data","isLoading":true}, {"name":"origin_income","isLoading":true}, {"name":"buy_data","isLoading":true}, {"name":"cp_data","isLoading":true}, {"name":"profit_data","isLoading":true} ],
      chartIndex:0,
      loading:false,
      loadingChart:false,

      get_issued_app_platform:[],
      pholder: "",
      maxPage: 1,
      config: [],
      editDialog: false,
      group: {},
      dateVal: [
        new Date(new Date().getTime() - 3600 * 1000  * 24)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, start]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
       option: {
	       	title: {
			        text: '折线图堆叠'
			    },
	        tooltip: {
	          trigger: "axis"
	        },
	        legend: {
	          data: [
	            "新增访问人数",
	          ]
	        },
	        toolbox: {
	          show: true,
	          feature: {
	            saveAsImage: { show: true }
	          }
	        },
	        xAxis: {
	          type: "category",
	          data: []
	        },
	        yAxis: {
	          type: "value"
	        },
	        series: [
	          // "总访问人数", "总新增访问人数", "总收入","利润","买量成本","ROI"
	          { name: "新增访问人数", type: "line", smooth: true, data: [] },
	        ],
	        color: [
	          "#ee4f54",
	        ]
      },
       color: [
          "#61c0a0",
          "#ee4f54",
          "#8ec1b0",
          "#a6e8ba",
          "#ceead4",
          "#f2e247",
          "#f6e98b",
          "#f77b31",
          "#fc9656",
          "#ec151a",
          "#ee4f54",
          "#ee2159",
          "#fbaaa6"
        ],
    };
  },
  watch: {
    dateVal: {
      handler(n, o) {
        if (n[0]) {
          this.pdata.sdate = n[0];
          this.pdata.edate = n[1];
          this.chartIndex=0;
	  			this.chartParams.map((v,i)=>{
					  		v.isLoading = true;
					  		return v;
					  	})
		    	this.getDataChart();
        }
      },
      deep: true
    }
  },
  methods: {
  	changeDate(s) {
      this.dateVal = [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * s)
          .toISOString()
          .slice(0, 10),
        new Date(new Date().getTime() - 3600 * 1000 * 24)
          .toISOString()
          .slice(0, 10)
      ];
      // this.getList();
    },
    getDataBorad(){
    		var _this=this;
    	  _this.cardParams[_this.cardIndex].isLoading=true;
    		var p = "module=card&fragment="+_this.cardParams[_this.cardIndex].name+"&";
				for(var k in _this.pdata) {
					// if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
					if(_this.pdata[k]) p += k + "=" + _this.pdata[k] + "&";
				}
    		getSummaryIndex(p, _this.$cookie.getCookie("login")).then(res => {
    			
					if(res.code == 200) {
						console.log(_this.card)
						_this.cardParams[_this.cardIndex].isLoading=false;
						Object.assign( _this.card, res.data.card);
//						 _this.card.push(res.data.card);
						
						_this.cardIndex++;
		    			if(_this.cardIndex<8){
		    				_this.getDataBorad();
		    			}
		    			else{
		    				_this.chartIndex=0;
		    				_this.chartParams.map((v,i)=>{
						  		v.isLoading = true;
						  		return v;
						  	})
		    				_this.getDataChart();
		    			}
						
					}
				});
    },
    getDataChart(){
    	var _this=this;
    	_this.chartParams[_this.chartIndex].isLoading=true;
    	var p = "module=chart&fragment="+_this.chartParams[_this.chartIndex].name+"&";
				for(var k in _this.pdata) {
					// if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
					if(_this.pdata[k]) p += k + "=" + _this.pdata[k] + "&";
				}
    		getSummaryIndex(p, _this.$cookie.getCookie("login")).then(res => {
    
    			_this.chartParams[_this.chartIndex].isLoading=false;
					if(res.code == 200) {
							var option_date =[];
   					  var option_series_data = [];
   					  if(res.data.chart){
	     					for(let key  in res.data.chart[_this.chartParams[_this.chartIndex].name]){
							 		option_date.push(key);
							 		option_series_data.push(res.data.chart[_this.chartParams[_this.chartIndex].name][key]);
								}
	     					
	     					_this.option.xAxis.data = option_date;
	     					
	     					switch(_this.chartParams[_this.chartIndex].name){
	     						case 'visit_uv_new':
			     						_this.option.series[0] = { name: "累计新增", type: "line", smooth: true, data:option_series_data }; 
			     						_this.option.title.text= "累计新增";
			     						_this.option.color[0] = _this.color[0];
			     						break;
	     						case 'visit_uv':
			     						_this.option.series[0] = { name: "活跃", type: "line", smooth: true, data:option_series_data };
			     						_this.option.title.text= "累计活跃"; 
			     						_this.option.color[0] = _this.color[1];
	     						break;
	     						case 'origin_income':
			     						_this.option.series[0] = { name: "广告收入", type: "line", smooth: true, data:option_series_data };
			     						_this.option.title.text= "广告收入"; 
			     						_this.option.color[0] = _this.color[2];	
			     						break;
	     						case 'buy_data':
			     						_this.option.series[0] = { name: "买量支出", type: "line", smooth: true, data:option_series_data };
			     						_this.option.title.text= "买量支出"; 
			     						_this.option.color[0] = _this.color[3];	
			     						break;
	     						case 'cp_data': 
			     						_this.option.series[0] = { name: "CP分成", type: "line", smooth: true, data:option_series_data };
			     						_this.option.title.text= "CP分成";
			     						_this.option.color[0] = _this.color[4];
			     						break;
	     						case 'profit_data': 
			     						_this.option.series[0] = { name: "发行利润", type: "line", smooth: true, data:option_series_data };
			     						_this.option.title.text= "发行利润";
			     						_this.option.color[0] = _this.color[5];
			     						break;
	     						case 'sell_data': 
			     						_this.option.series[0] = { name: "卖量含矩阵", type: "line", smooth: true, data:option_series_data };
			     						_this.option.title.text= "卖量含矩阵";
			     						_this.option.color[0] = _this.color[6];
			     						break;
	     					}
	     					
	     					_this.drawColumnChart(JSON.parse(JSON.stringify(_this.option)) ,_this.chartParams[_this.chartIndex].name);
								_this.chartIndex++;
							}
							
							if(_this.chartIndex<7){
		    				_this.getDataChart();
		    		}
							
					}
				});
    },
    getSelectField() {
				var _this = this;
				var p = "position=product_daily_index";
			  getValidProductPlatform(p, this.$cookie.getCookie("login")).then((res)=>{
						if(res.code == 200) {
							this.get_issued_app_platform = res.data;
						}
				})
			
			},
		drawColumnChart(otpins,string) {
      this.chartColumn = echarts.init(document.getElementById('option_'+string));
      this.chartColumn.setOption(otpins);
    },	
    updateBuy(id){
      console.log(id)
    },
    getField() {
    	this.cardIndex=0;
    	this.cardParams.map((v,i)=>{
	  		v.isLoading = true;
	  		return v;
	  	})
  		this.getDataBorad();
    },
    changeId(res) {
				this.pdata.issued_app_id = res;
				this.cardIndex=0;
				this.cardParams.map((v,i)=>{
		  		v.isLoading = true;
		  		return v;
		  	})
  			this.getDataBorad();
			}
  },
  created(){
  	this.getSelectField();
  	this.cardIndex=0;
  	this.cardParams.map((v,i)=>{
  		v.isLoading = true;
  		return v;
  	})
  	this.getDataBorad();
  },
  update(){
 
  },

  mounted() {
  	



    var _this=this;
  }
};
</script>

<style lang="scss">
.el-button + .el-button {
  margin-left: 0;
}
#chart > div {
  margin: 0 auto;
}
</style>

<style lang="scss" scoped="scoped">
	.card{
		padding: 15px 15px;
		border: 1px solid #82d4f8;
		background: #ecf5ff;
		border-radius: 5px;
		margin-bottom: 10px;
		.cdName{
			overflow: hidden;
			position: relative;
			line-height: 30px;
			b{
				font-size: 16px;
				
			}
			span{
				font-size: 12px;
				position: absolute;
				right: 0;
			}
		}
		.today{
			height: 80px;
			line-height: 80px;
			span{
				font-size: 38px;
			}
		}
		.yestoday{
			height: 25px;
			line-height: 25px;
			span{
					&.up{
					color: #e0546a;
					}
					&.down{
						color: #67c48f;
						b{
							&.none{
								color: #333333;
							}
						}
					}
			}
		
		}
	}
</style>

<style >
.total.el-row::before,
.total.el-row::after {
  content: table;
}
.total {
  min-width: 1200px;
  padding: 15px 10px;
  background: #f2f6fc;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  text-align: center;
}
.box-card {
  /* width: 260px; */
  margin: 10px;
  float: left;
}
.sicon {
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding: 10px;
  border-radius: 10px;
  background: #67c23a;
  text-align: center;
  font-size: 25px;
  color: white;
}
.sicon.c1 {
  background: #67c23a;
}
.sicon.c2 {
  background: #409eff;
}
.sicon.c3 {
  background: #e6a23c;
}
.sicon.c4 {
  background: #f56c6c;
}
.sicon.c5 {
  background: #909399;
}

.tjContent {
  display: inline-block;
  vertical-align: middle;
  font-size: 20px;
  margin-left: 10px;
}
.tjContent > div {
  height: 25px;
  line-height: 25px;
  font-size: 16px;
}

.tjContent > div.numText {
  font-size: 28px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
  color: brown;
}
.tjContent > div.numText.t1 {
  color: #67c23a;
}
.tjContent > div.numText.t2 {
  color: #409eff;
}
.tjContent > div.numText.t3 {
  color: #e6a23c;
}
.tjContent > div.numText.t4 {
  color: #f56c6c;
}
.tjContent > div.numText.t5 {
  color: #909399;
}
</style>


<style>
	@media only screen and (max-width: 767px) {
	.total{
		min-width: 100% !important;
	}
	.xs24{
		width: 100% !important;
		margin: 5px 0;
	}
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 60px;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// dataBoard.vue?5cdbb8ad